"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRadioButtonStyles = exports.radioButtonVars = exports.radioButtonCommon = void 0;
var _createUseStyles = _interopRequireDefault(require("../../../themes/createUseStyles"));
var _commonProps = require("../../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var radioButtonCommon = exports.radioButtonCommon = _commonProps.defaultCommonProps;
var radioButtonVars = exports.radioButtonVars = (0, _initVars.default)({
  applied: radioButtonCommon,
  variables: [{
    key: "rootAlignItems"
  }, {
    key: "rootCursor"
  }, {
    key: "checkedInputColor",
    canHaveColor: true
  }]
});
var styles = function styles(theme) {
  var size = 18;
  var checkSize = size - 10;
  return {
    variables: radioButtonVars.styles,
    root: {
      display: "inline-flex",
      alignItems: radioButtonVars.get("rootAlignItems"),
      fontFamily: theme.typography.fontFamily,
      lineHeight: "".concat(theme.spacing.base * 2.5, "px"),
      cursor: radioButtonVars.get("rootCursor"),
      position: "relative",
      fontWeight: theme.typography.fontWeight,
      fontSize: theme.typography.fontSize,
      color: theme.colors.baseContrast070
    },
    stretch: {
      justifyContent: "space-between",
      width: "100%"
    },
    rootDisabled: {
      color: theme.colors.baseContrast040
    },
    input: {
      opacity: 0,
      zIndex: -1,
      position: "absolute",
      "&:checked + div": {
        borderColor: radioButtonVars.get("checkedInputColor", theme.colors.primary),
        "&:before": {
          backgroundColor: radioButtonVars.get("checkedInputColor", theme.colors.primary)
        }
      },
      "&:checked:disabled + div": {
        borderColor: theme.colors.baseContrast030,
        "&:before": {
          backgroundColor: theme.colors.baseContrast030
        }
      }
    },
    flip: {
      flexDirection: "row-reverse",
      "& $check": {
        marginInlineStart: theme.spacing.base,
        marginInlineEnd: 0
      }
    },
    check: {
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "2px solid ".concat(theme.colors.baseContrast060),
      borderRadius: "100%",
      height: size,
      width: size,
      minWidth: size,
      transition: "border-color .3s ease, box-shadow .3s ease",
      margin: 0,
      marginInline: 0,
      marginInlineEnd: theme.spacing.base,
      "&:before": {
        content: "''",
        height: checkSize,
        width: checkSize,
        borderRadius: "100%",
        transition: "all .3s ease"
      }
    },
    disabled: {
      border: "2px solid ".concat(theme.colors.baseContrast030)
    },
    hint: {
      fontSize: theme.typography.fontSize - 2,
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast050
    },
    description: {
      fontSize: theme.typography.fontSize - 2,
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast050
    }
  };
};
var useRadioButtonStyles = exports.useRadioButtonStyles = (0, _createUseStyles.default)(styles, {
  name: "RadioButton"
});